import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is Advanced Benefit Design?',
      answer: 'We are a financial advice firm that can guide you through a variety of different financial tools that can protect you from risks. This includes Lifetime Income, mortgage protection, IUL for Kids, and Estate Planning.'
    },
    {
      question: 'I already have life insurance, why consider Long-Term Care Planning?',
      answer: 'Life insurance helps loved ones after you\'re gone; Long-Term Care Planning supports you if an illness or injury makes daily activities difficult. It lines up resources for in-home help or a care facility so routines, bills, and family goals stay on track. You choose how and where you prefer to receive care, and we tailor options to your budget and timeline.'
    },
    {
      question: 'How do I make a tax-free retirement plan?',
      answer: 'IUL\'s provide an effective tool to grow your investments during stock market booms, that also cap your investment losses during a stock market decline. This program\'s benefits are tax free, and can payout after retirement in a steady income stream.'
    },
    {
      question: 'What benefits does a Mortgage Protection Plan provide?',
      answer: 'If you pass away or if you become too sick to make mortgage payments, the Mortgage Protection Plan will send you or your beneficiary money in order to pay off your mortgage. This can protect new homeowners or their families from bankruptcy or foreclosure in the event of a major life crisis.'
    },
    {
      question: 'What kind of services can you provide my business?',
      answer: 'We look into your business and give you personal advice on how to transfer, sell, or use your business for retirement. We also guide you through a variety of contingencies in case a key member of your staff or partner is unable to continue working for that business.'
    },
    {
      question: 'What do you do for Estate Planning?',
      answer: 'We will go over with you your will, set up trusts, and work on securing estate exemptions that can shield your estate from unnecessary taxes or arbitrations. We can assist you in setting a power of attorney and choosing an executor for your will.'
    },
    {
      question: 'What is Lifetime Income and how does it work?',
      answer: 'Lifetime Income turns a portion of your savings into dependable monthly paychecks designed to last as long as you do. It pairs growth potential linked to market performance (without direct market exposure) with features that help protect your principal from losses.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Your Financial Questions, <span className="text-teal-600">Answered</span>
          </h2>
          <p className="text-lg text-slate-600">
            Get clarity on our services and how we can help secure your financial future.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-xl border border-slate-200 overflow-hidden hover:border-teal-300 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-slate-100 transition-colors"
              >
                <span className="text-lg font-semibold text-slate-900 pr-4">
                  {faq.question}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-teal-500 text-white transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-slate-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
